import clsx from 'clsx';
import { Order, OrderStatus } from '../api-new';
import {
  format_date,
  format_duration,
  format_percentage,
} from '../shared/formatters';
import { WasteValue } from '../shared/waste-value';
import { OrderStatusBadge } from './order-status-badge';

export const COLS_FULL: {
  key: keyof Order;
  label: React.ReactNode;
  truncate?: boolean;
  searchable: boolean;
  sortable: boolean;
  cell?: (row: Order) => React.ReactNode;
}[] = [
  { key: 'wo_code', label: 'ID Ordine', searchable: true, sortable: true },
  {
    key: 'wk_status_code',
    label: 'Status',
    searchable: true,
    sortable: true,
    cell: (row) => <OrderStatusBadge status={row.wk_status_code} />,
  },
  { key: 'ar_code', label: 'Cod. Articolo', searchable: true, sortable: true },
  {
    key: 'ar_name',
    label: 'Descr. Articolo',
    truncate: true,
    searchable: true,
    sortable: true,
  },
  {
    key: 're_code',
    label: 'Progr. Saldatura',
    searchable: true,
    sortable: true,
    cell: (row) => (
      <span
        className={clsx(
          row.wk_status_code === OrderStatus.SCHEDULED && 'text-blue-500',
        )}>
        {row.re_code}
      </span>
    ),
  },
  {
    key: 'wo_ordered_quantity',
    label: 'Q.tà',
    searchable: false,
    sortable: false,
  },
  {
    key: 'wk_goods',
    label: (
      <span>
        Buoni <small className="font-light">(%)</small>
      </span>
    ),
    searchable: false,
    sortable: false,
    cell: (row) => (
      <span className="text-green-500">
        <b>{row.wk_goods}</b>
        <small className="ml-1">
          ({format_percentage(row.wk_goods / row.wo_ordered_quantity)})
        </small>
      </span>
    ),
  },
  {
    key: 'wk_wastes',
    label: 'Scarti',
    searchable: false,
    sortable: false,
    cell: (row) => <WasteValue value={row.wk_wastes} />,
  },
  {
    key: 'wk_unix_start',
    label: (
      <span>
        Data/Ora Avvio <span className="text-blue-500 font-light">(EXP.)</span>
      </span>
    ),
    searchable: false,
    sortable: true,
    cell: (row) => {
      if (row.wk_unix_start === 0) return '-';
      return (
        <span
          className={clsx(
            row.wk_status_code === OrderStatus.SCHEDULED && 'text-blue-500',
          )}>
          {format_date(row.wk_unix_start)}
        </span>
      );
    },
  },
  {
    key: 'wk_working_time',
    label: 'Durata',
    searchable: false,
    sortable: false,
    cell: (row) =>
      format_duration((row.wk_setup_time + row.wk_working_time) * 1000),
  },
  {
    key: 'wk_working_time',
    label: 'Durata prevista',
    searchable: false,
    sortable: false,
    cell: (row) =>
      format_duration(
        (row.wk_expected_setup_time + row.wk_expected_working_time) * 1000,
      ),
  },
  {
    key: 'wk_unix_finish',
    label: (
      <span>
        Data/Ora Termine{' '}
        <span className="text-blue-500 font-light">(EXP.)</span>
      </span>
    ),
    searchable: false,
    sortable: true,
    cell: (row) => {
      if (row.wk_unix_finish === 0) return '-';
      return (
        <span
          className={clsx(
            row.wk_status_code === OrderStatus.SCHEDULED && 'text-blue-500',
          )}>
          {format_date(row.wk_unix_finish)}
        </span>
      );
    },
  },
];

export const COLS_COMPACT = COLS_FULL.filter((col) =>
  [
    'id',
    'order',
    'item',
    'description',
    'program',
    'quantity',
    'started_at',
    'ended_at',
  ].includes(col.key),
);
